"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/payment-settlement.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fpayment-settlement.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.settlementPortionTypeToJSON = exports.settlementPortionTypeFromJSON = exports.FundedSettlementPortion = exports.PaidSettlementPortion = exports.SettlementPortion = exports.SettlementPaymentContext = exports.SettlementPortionType = void 0;
const amount_1 = require("../common/amount");
const protobufPackage = 'com.step.common.proto';
var SettlementPortionType;
(function (SettlementPortionType) {
    SettlementPortionType["INVALID_SETTLEMENT_PORTION"] = "INVALID_SETTLEMENT_PORTION";
    SettlementPortionType["SECURED_PORTION"] = "SECURED_PORTION";
    SettlementPortionType["UNSECURED_95_PERCENT_PORTION"] = "UNSECURED_95_PERCENT_PORTION";
    SettlementPortionType["UNSECURED_5_PERCENT_PORTION"] = "UNSECURED_5_PERCENT_PORTION";
    SettlementPortionType["UNSECURED_PORTION"] = "UNSECURED_PORTION";
    SettlementPortionType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(SettlementPortionType || (exports.SettlementPortionType = SettlementPortionType = {}));
function createBaseSettlementPaymentContext() {
    return {
        settlementId: '',
        networkSettlementId: '',
        portions: [],
        settlementTimeMs: '0',
        transactionCount: '0',
    };
}
exports.SettlementPaymentContext = {
    fromJSON(object) {
        const message = {
            settlementId: isSet(object.settlementId) ? globalThis.String(object.settlementId) : '',
            networkSettlementId: isSet(object.networkSettlementId)
                ? globalThis.String(object.networkSettlementId)
                : '',
        };
        if (globalThis.Array.isArray(object?.portions)) {
            message.portions = object.portions.map((e) => exports.SettlementPortion.fromJSON(e));
        }
        if (isSet(object.settlementTimeMs)) {
            message.settlementTimeMs = globalThis.String(object.settlementTimeMs);
        }
        if (isSet(object.transactionCount)) {
            message.transactionCount = globalThis.String(object.transactionCount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.settlementId !== '') {
            obj.settlementId = message.settlementId;
        }
        if (message.networkSettlementId !== '') {
            obj.networkSettlementId = message.networkSettlementId;
        }
        if (message.portions?.length) {
            obj.portions = message.portions.map((e) => exports.SettlementPortion.toJSON(e));
        }
        if (message.settlementTimeMs !== undefined && message.settlementTimeMs !== '0') {
            obj.settlementTimeMs = message.settlementTimeMs;
        }
        if (message.transactionCount !== undefined && message.transactionCount !== '0') {
            obj.transactionCount = message.transactionCount;
        }
        return obj;
    },
    create(base) {
        return exports.SettlementPaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSettlementPaymentContext();
        message.settlementId = object.settlementId ?? '';
        message.networkSettlementId = object.networkSettlementId ?? '';
        message.portions = object.portions?.map((e) => exports.SettlementPortion.fromPartial(e)) || [];
        message.settlementTimeMs = object.settlementTimeMs ?? '0';
        message.transactionCount = object.transactionCount ?? '0';
        return message;
    },
};
function createBaseSettlementPortion() {
    return {
        type: SettlementPortionType.INVALID_SETTLEMENT_PORTION,
        total: amount_1.Amount.fromPartial({}),
        paid: undefined,
        funded: undefined,
    };
}
exports.SettlementPortion = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type)
                ? settlementPortionTypeFromJSON(object.type)
                : SettlementPortionType.INVALID_SETTLEMENT_PORTION,
            total: isSet(object.total) ? amount_1.Amount.fromJSON(object.total) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.paid)) {
            message.paid = exports.PaidSettlementPortion.fromJSON(object.paid);
        }
        if (isSet(object.funded)) {
            message.funded = exports.FundedSettlementPortion.fromJSON(object.funded);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== SettlementPortionType.INVALID_SETTLEMENT_PORTION) {
            obj.type = settlementPortionTypeToJSON(message.type);
        }
        if (message.total !== undefined) {
            obj.total = amount_1.Amount.toJSON(message.total);
        }
        if (message.paid !== undefined) {
            obj.paid = exports.PaidSettlementPortion.toJSON(message.paid);
        }
        if (message.funded !== undefined) {
            obj.funded = exports.FundedSettlementPortion.toJSON(message.funded);
        }
        return obj;
    },
    create(base) {
        return exports.SettlementPortion.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSettlementPortion();
        message.type = object.type ?? SettlementPortionType.INVALID_SETTLEMENT_PORTION;
        message.total = (object.total !== undefined && object.total !== null)
            ? amount_1.Amount.fromPartial(object.total)
            : amount_1.Amount.fromPartial({});
        message.paid = (object.paid !== undefined && object.paid !== null)
            ? exports.PaidSettlementPortion.fromPartial(object.paid)
            : undefined;
        message.funded = (object.funded !== undefined && object.funded !== null)
            ? exports.FundedSettlementPortion.fromPartial(object.funded)
            : undefined;
        return message;
    },
};
function createBasePaidSettlementPortion() {
    return { referenceId: '', paidAtMs: '0' };
}
exports.PaidSettlementPortion = {
    fromJSON(object) {
        const message = {
            referenceId: isSet(object.referenceId) ? globalThis.String(object.referenceId) : '',
            paidAtMs: isSet(object.paidAtMs) ? globalThis.String(object.paidAtMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        if (message.paidAtMs !== '0') {
            obj.paidAtMs = message.paidAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.PaidSettlementPortion.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePaidSettlementPortion();
        message.referenceId = object.referenceId ?? '';
        message.paidAtMs = object.paidAtMs ?? '0';
        return message;
    },
};
function createBaseFundedSettlementPortion() {
    return { referenceId: '', fundedAtMs: '0' };
}
exports.FundedSettlementPortion = {
    fromJSON(object) {
        const message = {
            referenceId: isSet(object.referenceId) ? globalThis.String(object.referenceId) : '',
            fundedAtMs: isSet(object.fundedAtMs) ? globalThis.String(object.fundedAtMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        if (message.fundedAtMs !== '0') {
            obj.fundedAtMs = message.fundedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.FundedSettlementPortion.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFundedSettlementPortion();
        message.referenceId = object.referenceId ?? '';
        message.fundedAtMs = object.fundedAtMs ?? '0';
        return message;
    },
};
function settlementPortionTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_SETTLEMENT_PORTION':
            return SettlementPortionType.INVALID_SETTLEMENT_PORTION;
        case 1:
        case 'SECURED_PORTION':
            return SettlementPortionType.SECURED_PORTION;
        case 2:
        case 'UNSECURED_95_PERCENT_PORTION':
            return SettlementPortionType.UNSECURED_95_PERCENT_PORTION;
        case 3:
        case 'UNSECURED_5_PERCENT_PORTION':
            return SettlementPortionType.UNSECURED_5_PERCENT_PORTION;
        case 4:
        case 'UNSECURED_PORTION':
            return SettlementPortionType.UNSECURED_PORTION;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return SettlementPortionType.UNRECOGNIZED;
    }
}
exports.settlementPortionTypeFromJSON = settlementPortionTypeFromJSON;
function settlementPortionTypeToJSON(object) {
    switch (object) {
        case SettlementPortionType.INVALID_SETTLEMENT_PORTION:
            return 'INVALID_SETTLEMENT_PORTION';
        case SettlementPortionType.SECURED_PORTION:
            return 'SECURED_PORTION';
        case SettlementPortionType.UNSECURED_95_PERCENT_PORTION:
            return 'UNSECURED_95_PERCENT_PORTION';
        case SettlementPortionType.UNSECURED_5_PERCENT_PORTION:
            return 'UNSECURED_5_PERCENT_PORTION';
        case SettlementPortionType.UNSECURED_PORTION:
            return 'UNSECURED_PORTION';
        case SettlementPortionType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.settlementPortionTypeToJSON = settlementPortionTypeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payment-settlement.js.map